import { useContext, useEffect, useRef, useState  } from "react";
import { useLocation, Navigate, useNavigate } from "react-router-dom"
import authContext from "../../context/authentication/authContex";

import './ErrorPage.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import Routes_gral from "../../utils/Routes_gral";

export const ErrorPage = ({}) => {

    const navigate = useNavigate();
    const filterByCodActivo = localStorage.getItem('activoToSearch');
    const OTtoFind = localStorage.getItem('OTtoFind');

    if(filterByCodActivo == null && OTtoFind == null){
        navigate(Routes_gral.login, {replace:true});
    }

    return <div className="errorPageContainer">
        <div className="msgErrorPageDiv">
            <h3>No posee acceso a esta ruta o esta es inexistente, comuniquese con su administrador</h3>
            <FontAwesomeIcon className="errorPageIcon" icon={faTimes}/>
        </div>
    </div>

}